export const colors = {
	red: '#df0030',
	yellow: '#f8b322',
	blue: '#1998d1',
	green: '#17a345',
	purple: '#cc50f2',
	orange: '#ff7f4f',
	white: '#fcfcfc'
}
